import { render, staticRenderFns } from "./agreements-layout.vue?vue&type=template&id=79aada76&scoped=true&"
import script from "./agreements-layout.vue?vue&type=script&lang=js&"
export * from "./agreements-layout.vue?vue&type=script&lang=js&"
import style0 from "./agreements-layout.vue?vue&type=style&index=0&id=79aada76&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79aada76",
  null
  
)

export default component.exports